var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.referrerId && _vm.showPopUpId >= 0 && !_vm.isShopBuilder
    ? _c("div", { staticClass: "hv-referrer-popup" }, [
        _c(
          "div",
          {
            staticClass: "modal fade",
            attrs: {
              id: "NotifiyPopUp",
              tabindex: "-1",
              role: "dialog",
              "aria-labelledby": "notifiyPopUp",
              "aria-hidden": "true",
            },
          },
          [
            _c(
              "div",
              { staticClass: "modal-dialog", attrs: { role: "document" } },
              [
                _c("div", { staticClass: "modal-content" }, [
                  _c("div", { staticClass: "modal-header" }, [
                    _c(
                      "h5",
                      {
                        staticClass: "modal-title",
                        attrs: { id: "exampleModalLongTitle" },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$translate(
                              "ZeitloungeTheme::Template.popUpReferrerModal" +
                                _vm.showPopUpId +
                                "ModalTitle"
                            )
                          )
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm._m(0),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-body" }, [
                    _c(
                      "div",
                      { staticClass: "article", attrs: { id: "content" } },
                      [
                        _c("h2", [
                          _vm._v(
                            _vm._s(
                              _vm.$translate(
                                "ZeitloungeTheme::Template.popUpReferrerModal" +
                                  _vm.showPopUpId +
                                  "ContentTitle"
                              )
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$translate(
                                "ZeitloungeTheme::Template.popUpReferrerModal" +
                                  _vm.showPopUpId +
                                  "ContentHtmlText"
                              )
                            ),
                          },
                        }),
                      ]
                    ),
                  ]),
                ]),
              ]
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close",
        },
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }